export interface Category {
  id: string;
  slug: string;
  name: string;
  icon: string;
  description: string;
  gameCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'action-adventure',
    name: '动作冒险',
    icon: 'ri-sword-line',
    description: '探索未知世界，挑战强大敌人，体验肾上腺素飙升的动作快感',
    gameCount: 5,
  },
  {
    id: 'cat-2',
    slug: 'rpg',
    name: '角色扮演',
    icon: 'ri-user-star-line',
    description: '沉浸于丰富的故事世界，塑造属于你的传奇角色',
    gameCount: 3,
  },
  {
    id: 'cat-3',
    slug: 'strategy-simulation',
    name: '策略模拟',
    icon: 'ri-brain-line',
    description: '运筹帷幄，深思熟虑，在策略的世界中展现你的智慧',
    gameCount: 3,
  },
  {
    id: 'cat-4',
    slug: 'casual-puzzle',
    name: '休闲益智',
    icon: 'ri-gamepad-line',
    description: '轻松上手，随时畅玩，在碎片时间中享受游戏乐趣',
    gameCount: 4,
  },
];